import { type CSSProperties, forwardRef, type ReactNode } from 'react';
import SimpleBar from 'simplebar-react';

import { classList } from '@/utils/cn';

import 'simplebar-react/dist/simplebar.min.css';

interface ScrollAreaProps {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}

export const ScrollArea = forwardRef<HTMLDivElement, ScrollAreaProps>(
  ({ children, className, style }, ref) => {
    return (
      <SimpleBar
        scrollableNodeProps={{ ref }}
        className={classList(
          '[&_.simplebar-scrollbar]:before:bg-gray-8',
          className
        )}
        tabIndex={-1}
        style={style}
      >
        {children}
      </SimpleBar>
    );
  }
);
